"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API3B_ROOT = exports.API3_ROOT = exports.API2_ROOT = exports.API1B_ROOT = exports.API1_ROOT = void 0;
exports.API1_ROOT = '/_api/v1';
exports.API1B_ROOT = '/_api/api/v1';
exports.API2_ROOT = '/_api/api/v2';
exports.API3_ROOT = '/_api/v3';
exports.API3B_ROOT = '/_api/api/v3';
